import { useState } from "react";
import { Box, Button, IconButton, InputBase, Paper, SpeedDial, SpeedDialIcon, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { useQuery } from "react-query";
import { reasonsRequestsFn } from "../../../services/reasonsRequest";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import SearchIcon from '@mui/icons-material/Search';
import ReasonManager from "./manager";
import CustomTableCell from "../../shared/CustomTable/CustomTableCell";

const Reasons = () => {

  const [filter, setFilter] = useState('');
  const { data : rows, isLoading, refetch } = useQuery(["reasons-requests-table"], () => reasonsRequestsFn({}));
  const [values, setValues] = useState({});
  const [open, setOpen] = useState(false);

  // Sem id, o diálogo entra em modo de inclusão.
  const handleNew = () => {
    setValues({ level: 1, type: '' });
    setOpen(true);
  }

  const handleEdit = (reason) => {
    setValues({ ...reason });
    setOpen(true);
  }

  const term = filter.toLowerCase();
  const filtered = (rows || []).filter((row) =>
    (row.description || '').toLowerCase().includes(term) || (row.type || '').toLowerCase().includes(term)
  );

  return (
    <Box sx={{ width: '100%', height: '100%', p: 2}}>
      <Paper elevation={3} sx={{ p: '2px 4px', display: 'flex',  mb: 2, border: '1px solid rgba(0, 0, 0, 0)', ':hover': { border: '1px solid' } }}>
        <InputBase
            sx={{ ml: 1, flex: 1 }}
            placeholder="Filtrar por descrição ou seguimento"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
        />
        <IconButton type="button" sx={{ p: '10px' }} title='Buscar' >
            <SearchIcon />
        </IconButton>
      </Paper >
      <SpeedDial
        ariaLabel="Novo tipo de atendimento"
        sx={{ position: 'fixed', bottom: 120, right: 16 }}
        icon={<SpeedDialIcon />}
        onClick={handleNew}
      >
      </SpeedDial>
      <Paper >
        <TableContainer sx={{ overflow: 'scroll', height: '80vh'}} >
          <Table stickyHeader  sx={{ width: '100%' }} >
            <TableHead>
              <TableRow>
                  <CustomTableCell>id</CustomTableCell>
                  <CustomTableCell>Descrição</CustomTableCell>
                  <CustomTableCell>Nível</CustomTableCell>
                  <CustomTableCell>Tipo</CustomTableCell>
                  <CustomTableCell>Editar</CustomTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
            {filtered.map((row) => (
              <TableRow key={row.id} sx={{height: '15px'}} >
                <CustomTableCell component="th" scope="row">{row.id}</CustomTableCell>
                <CustomTableCell align="left">{row.description}</CustomTableCell>
                <CustomTableCell align="left">{row.level}</CustomTableCell>
                <CustomTableCell align="left">{row.type}</CustomTableCell>
                <CustomTableCell align="left">
                  <Button onClick={() => handleEdit(row)}>
                      <EditOutlinedIcon />
                  </Button></CustomTableCell>
              </TableRow>
            ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
      <ReasonManager
        values={values}
        setValues={setValues}
        open={open}
        setOpen={setOpen}
        handleChanged={refetch}
      />
    </Box>
  )
}

export default Reasons;
